import { getAllInstitutes } from "./Pages/api/institute"
import './App.css';

import LandingPage from './Pages/LandingPage/page';
import React, { useEffect, useState, useCallback } from "react";
import { BrowserRouter, Routes, Route, useParams, useNavigate } from "react-router-dom";
import StudentDashboard from './Pages/Dashboard/studentDashboard';
import InstituteDashboard from './Pages/InstituteDashboard/page';
import PageConfiuration from './Pages/AdminPages/pagesconfiguration/PageConfiguration/page';
import CourseWiseDocument from './Pages/AdminPages/coursewisedocuments/CourseWiseDocument/page';
import CategoryType from './Pages/AdminPages/master/CategoryType/page';
import InstructionUpload from './Pages/AdminPages/master/InstructionUploading/page';
import RegistrationFees from './Pages/AdminPages/master//RegistrationFees/page';
import StudentInstruction from './Pages/StudentInstruction/page';
import ApplicationConfiguration from './Pages/AdminPages/adminActivity/Applicationconfiguration/page';
import ProjectConfigurations from './Pages/AdminPages/adminActivity/Projectconfiguration/page';
import SocialReservation from './Pages/AdminPages/master/SocialReservation/page';
import UpdateStudentDetails from './Pages/AdminPages/adminActivity/Updatestudnetdetails/page';
import UnlockRegistrationStudent from './Pages/AdminPages/adminActivity/UnlockRegistration/page';
import DateConfiguration from './Pages/AdminPages/dateconfiguration/dateConfiguration/page';
import MasterLandingPage from "./Pages/MasterLandingPage/page";
import Header from "./Pages/Header/page";
import UserService from "./service/UserService";
import MenuHeader from "./Pages/Header/menuHeader";
import BulkStudentVerification from "./Pages/AdminPages/adminActivity/StudentBulkVerification/page";
import SessionTimeout from "./Pages/SessionTimeout/page";
import SessionTimeoutManager from "./Pages/SessionTimeout/page";
import PageError from "./Pages/ErrorPage/page";

function App() {
  return (
    <>
      <BrowserRouter>
        <SessionTimeout timeout={30 * 60 * 1000} />
        <Header />
        {/* <SessionTimeout timeoutDuration={2 * 60 * 1000} cacheDuration={10 * 60 * 1000} /> */}
        <Routes>
          <Route path="/" element={<MasterLandingPage />} />
          <Route path="/:institute" element={
            <LandingPage />
          } />
          <Route path="/student-instruction" element={<StudentInstruction />} />
          <Route path="/student-dashboard" element={<StudentDashboard />} />
          <Route path="/institute-dashboard" element={<InstituteDashboard />} />
          <Route path="/page-configuration" element={<PageConfiuration />} />
          <Route path="/course-wise-document" element={<CourseWiseDocument />} />
          <Route path="/category-type" element={<CategoryType />} />
          <Route path="/instruction-upload" element={<InstructionUpload />} />
          <Route path="/registration-fees" element={<RegistrationFees />} />
          <Route path="/social-reservation" element={<SocialReservation />} />
          <Route path="/application-configuration" element={<ApplicationConfiguration />} />
          <Route path="/project-configuration" element={<ProjectConfigurations />} />
          <Route path="/update-student-details" element={<UpdateStudentDetails />} />
          <Route path="/unlock-registration" element={<UnlockRegistrationStudent />} />
          <Route path="/date-configuration" element={<DateConfiguration />} />
          <Route path="/student-bulk-verification" element={<BulkStudentVerification />} />
          <Route path="/page-error" element={<PageError />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}
export default App;
